import { useQuery } from '@tanstack/react-query';
import { AuthPageShell, DoctorAvatar } from '@/components';
import { useAuthFetch } from '@/hooks';
import type { DoctorListItem } from '@dermalink/shared';
import styles from './DoctorsOverview.module.css';


export function DoctorsOverview() {
  const authFetch = useAuthFetch();

  const { data, isPending, isError } = useQuery<DoctorListItem[]>({
    queryKey: ['doctors'],
    queryFn: async () => {
      const res = await authFetch('/doctors');
      if (!res.ok) throw new Error('Failed to load doctors');
      return (await res.json()) as DoctorListItem[];
    },
  });

  const doctors = data ?? [];

  return (
    <AuthPageShell maxWidth="720px" padTop="16px">
      <section className={styles.pageCard}>
        <h1 className="page-heading">Dermatologen</h1>
        <p className={`text-muted ${styles.subheading}`}>
          Overzicht van beschikbare dermatologen.
        </p>

        {isPending && <p className="text-muted status-message">Laden...</p>}
        {isError && <p className="text-muted status-message">Kon artsenlijst niet laden.</p>}
        {!isPending && !isError && doctors.length === 0 && (
          <p className="text-muted status-message">Geen artsen beschikbaar.</p>
        )}

        {doctors.length > 0 && (
          <div className={styles.grid}>
            {doctors.map((doctor) => {
              const subtitle = doctor.organization_name ?? doctor.riziv_qualification ?? 'Dermatoloog';
              return (
                <article key={doctor.cognito_sub} className={styles.card}>
                  <DoctorAvatar doctor={doctor} circleClassName={styles.avatar} imageClassName={styles.avatarImage} />
                  <div className={styles.main}>
                    <p className={styles.name}>Dr. {doctor.first_name} {doctor.last_name}</p>
                    <p className={styles.subtitle}>{subtitle}</p>
                  </div>
                </article>
              );
            })}
          </div>
        )}
      </section>
    </AuthPageShell>
  );
}

